<template>
  <div class="register">
    <header-top></header-top>
    <div class="logo-view">
      <div class="logo">
        <img :src="logo" alt="">
      </div>
      <div class="welcome">
        <img :src="hy" alt="">
      </div>
    </div>
    <p class="goLogin">
      我已经注册，现在就
      <!-- <span>登录</span> -->
      <router-link to="/login">登录</router-link>
    </p>
    <div class="content">
      <div v-if="view" class="view1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户名：" prop="userName">
            <el-input type="text"
            placeholder="请输入6~60位数字、英文字母组成的用户名"
            suffix-icon="iconfont ys-yonghuming"
            v-model="ruleForm.userName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
          </el-form-item>
          <el-form-item label="登录密码：" prop="userPass">
            <el-input type="password"
            placeholder="请输入长度8~16位数字、字母、字符至少包含两种的密码"
            suffix-icon="iconfont ys-ai-password"
            v-model="ruleForm.userPass" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmPass">
            <el-input type="password" v-model.number="ruleForm.confirmPass" placeholder="请确认密码" suffix-icon="iconfont ys-ai-password"></el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-col :span="8">
              <el-checkbox v-model="checked">
                我已阅读并同意
              </el-checkbox>
            </el-col>
            <el-col :span="14">
              <span><a href="http://e-zt.cn/other/#d1" target="_blank">《E政通注册协议》</a></span>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button class="nextBtn" type="text" @click="submitForm('ruleForm')">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else class="view2">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm1" label-width="120px" class="demo-ruleForm">
          <el-form-item label="绑定手机：" prop="phone">
            <el-input type="text"
            placeholder="请输入手机号"
            v-model="ruleForm.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
          </el-form-item>
        </el-form>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2" label-width="120px" class="demo-ruleForm">
          <el-form-item label="短信验证码：" prop="msgCode">
            <el-col :span="8">
              <el-input type="text" maxlength="6" v-model="ruleForm.msgCode" placeholder="请输入验证码"></el-input>
            </el-col>
            <el-col :span="11" class="btns">
              <el-button :disabled='disabled' type="danger" @click="getCode('ruleForm1')">获取短信验证</el-button>
            </el-col>
            <el-col :span="5" class="btns">
              <span v-show="time > 0">{{time}}s</span>
            </el-col>
          </el-form-item>
          <el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button class="nextBtn" type="text" @click="goRegister('ruleForm1','ruleForm2')">立即注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/base/header/header'
export default {
  name: 'register',
  components: {
    'header-top': Header
  },
  data () {
    var validateUserName = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]{6,60}$/
      if (!value) {
        return callback(new Error('用户名不能为空'))
      } else if (!reg.test(value)) {
        return callback(new Error('请输入6~60位数字、英文字母组成的用户名'))
      } else {
        callback()
      }
    }
    var validateUserPass = (rule, value, callback) => {
      const regex = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/
      if (value === '') {
        callback(new Error('密码不能为空！'))
      } else if (!regex.test(value)) {
        callback(new Error('密码长度8~16位数字、字母、字符至少包含两种！'))
      } else {
        callback()
      }
    }
    var validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.userPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      var reg = /^1[34578]\d{9}$/
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validateMsgCode = (rule, value, callback) => {
      let reg = /^\d{6}$/
      if (value === '') {
        callback(new Error('短信验证码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入6位的数字'))
      } else {
        callback()
      }
    }
    return {
      logo: require('@/assets/images/login/logo.png'),
      hy: require('@/assets/images/login/hy.png'),
      checked: true,
      disabled: false,
      time: 0,
      view: true,
      ruleForm: {
        userName: '',
        userPass: '',
        confirmPass: '',
        phone: '',
        msgCode: ''
      },
      rules: {
        userName: [
          { required: true, validator: validateUserName, trigger: 'blur' }
        ],
        userPass: [
          { required: true, validator: validateUserPass, trigger: 'blur' }
        ],
        confirmPass: [
          { required: true, validator: validateConfirmPass, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        msgCode: [
          { required: true, validator: validateMsgCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checked) {
            this.view = false
          } else {
            this.$message({
              message: '请选阅读并同意《E政通注册协议》',
              type: 'warning'
            })
          }
        } else {
          return false
        }
      })
    },
    getCode (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.countDown()
        } else {
          return false
        }
      })
    },
    goRegister (formName1, formName2) {
      const self = this
      let flag = true
      self.$refs[formName1].validate((valid) => {
        if (valid) {
        } else {
          flag = false
          return false
        }
      })
      self.$refs[formName2].validate((valid) => {
        if (valid) {
        } else {
          flag = false
          return false
        }
      })
      if (flag) {
        const userName = self.ruleForm.userName
        // const password = self.ruleForm.userPass
        const password = self.$md5(self.ruleForm.userPass)
        const code = self.ruleForm.msgCode
        const tel = self.ruleForm.phone
        const url = `?userName=${userName}&password=${password}&code=${code}&tel=${tel}`
        self.$get(self.$allUrl.register + url).then(res => {
          if (res.code === '0') {
            self.$message({
              message: '恭喜您，注册成功！',
              type: 'success',
              onClose: function () {
                self.$router.push({
                  name: 'Login'
                })
              }
            })
          } else {
            self.$notify.error({
              title: '错误',
              message: res.message
            })
          }
        })
        // self.$message({
        //   message: '感谢您，注册成功！',
        //   type: 'success',
        //   onClose: function () {
        //     self.$router.push({
        //       name: 'Login'
        //     })
        //   }
        // })
      }
    },
    countDown () { // 倒计时
      const self = this
      self.disabled = true
      const tel = self.ruleForm.phone
      self.$get(self.$allUrl.getSendVerifyCode + `?tel=${tel}`).then(res => {
        if (res.code === '0') {
          self.time = 60
          const int = setInterval(function () {
            if (self.time > 1) {
              self.time -= 1
            } else {
              window.clearInterval(int)
              self.time = 0
              self.disabled = false
            }
          }, 1000)
        } else {
          self.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
  .register{
    width: 1200px;
    background-color: white;
    margin: auto;
    height: 1000px;
    .logo-view{
      display: flex;
      padding: 20px 120px;
      .logo{
        border-right: 1px solid #dddddd;
        padding: 0 20px 0 0;
      }
      .welcome{
        padding-left: 20px;
        img{
          margin-top: 20px;
        }
      }
    }
    .goLogin{
      text-align: right;
      font-size: 12px;
      padding: 0 120px;
      span{
        color: red;
        cursor: pointer;
      }
    }
    .content{
      padding: 0 120px;
      .nextBtn{
          width: 100%;
          background-image: url('../../assets/images/login/dl.png');
          background-repeat: no-repeat;
          background-size:100% 100%;
          height: 50px;
          color: #ffd2d9;
          font-size: 20px;
        }
      .view1, .view2{
        border: 1px solid #dddddd;
        padding: 40px 250px;
        .btns{
          padding-left: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/register.vue


// WEBPACK FOOTER //
// src/components/Login/register.vue